var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Box, Button, FormControl, FormLabel, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select } from '@chakra-ui/react';
import React from 'react';
import { StoreContext } from '@/app/uistore/Rootstore';
import { observer } from 'mobx-react';
let MediaPicker = class MediaPicker extends React.Component {
    componentDidMount() {
        const rstore = this.context;
    }
    switchDevice() {
        const rstore = this.context;
        rstore.mediastore.switchSelectedDevice();
    }
    render() {
        const rstore = this.context;
        const width = window.innerWidth > 1000 ? 1000 : window.innerWidth;
        const audiodev = rstore.mediastore.devices.filter((dv) => dv.kind === 'audioinput');
        const videodev = rstore.mediastore.devices.filter((dv) => dv.kind === 'videoinput');
        let ascount = 1;
        let vscount = 1;
        return React.createElement(Modal, { isOpen: rstore.mediastore.showdevicepicker, onClose: () => rstore.mediastore.setDevicePicker(false) },
            React.createElement(ModalOverlay, null),
            React.createElement(ModalContent, null,
                React.createElement(ModalHeader, null, "Choose Your Preferred Device"),
                React.createElement(ModalCloseButton, null),
                React.createElement(ModalBody, null,
                    React.createElement(Box, null,
                        React.createElement(FormControl, { id: "Audio" },
                            React.createElement(FormLabel, null, "Audio Device"),
                            React.createElement(Select, { onChange: (e) => rstore.mediastore.setAudioDevice(e.currentTarget.value), placeholder: "Select Audio Device" }, audiodev.map((dv) => React.createElement("option", { key: dv.deviceId, value: dv.deviceId }, dv.label !== '' ? dv.label : "Audio Source (" + ascount++ + ")")))),
                        videodev.length > 0 && React.createElement(FormControl, { mt: '20px', id: "vudio" },
                            React.createElement(FormLabel, null, "Video Device"),
                            React.createElement(Select, { onChange: (e) => rstore.mediastore.setVideoDevice(e.currentTarget.value), placeholder: "Select Video Device" }, videodev.map((dv) => React.createElement("option", { key: dv.deviceId, value: dv.deviceId }, dv.label !== '' ? dv.label : "Video Source (" + vscount++ + ")")))))),
                React.createElement(ModalFooter, null,
                    React.createElement(Button, { colorScheme: "blue", mr: 3, onClick: () => rstore.mediastore.setDevicePicker(false) }, 'Cancel'),
                    React.createElement(Button, { disabled: rstore.mediastore.hasDevice ? false : true, onClick: () => rstore.mediastore.switchmode ? this.switchDevice() : rstore.mediastore.pickedinit(), colorScheme: "green" }, 'Join'))));
    }
};
MediaPicker.contextType = StoreContext;
MediaPicker = __decorate([
    observer
], MediaPicker);
export { MediaPicker };
